<template>
  <div>
    <v-card class="pb-2">
      <v-card-title class="primary white--text">
        <span style="width: 100%"
          >Available Merge Fields
          <v-btn class="float-right" dark icon small @click="$emit('cancel')">
            <v-icon color="white--text" small>mdi-close</v-icon>
          </v-btn>
        </span>
      </v-card-title>
      <v-card-text class="pa-5 mt-2">
        <span>
          • Enclosed placeholders with 2 curly braces. <br />
          • No white spaces inside the curly braces to let data populate the
          placeholder(s) after merging.
        </span>
        <v-row>
          <v-col>
            <ag-grid-vue
              class="ag-theme-alpine"
              domLayout="autoHeight"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData1"
            ></ag-grid-vue>
          </v-col>
          <v-col>
            <ag-grid-vue
              class="ag-theme-alpine"
              domLayout="autoHeight"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData2"
            ></ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "LetterMergeFields",
  components: {
    AgGridVue,
  },
  data: () => ({
    columnDefs: null,
    rowData1: [],
    rowData2: [],
  }),
  beforeMount() {
    let vm = this;
    vm.columnDefs = [
      { headerName: "Data Name", field: "dataName" },
      { headerName: "Placeholder", field: "placeholder" },
    ];
    vm.rowData1 = [
      { dataName: "Customer Number", placeholder: "{{custNo}}" },
      { dataName: "Phone Number", placeholder: "{{phoneNumber}}" },
      { dataName: "Dealer ID", placeholder: "{{dealer_id}}" },
      { dataName: "First Name", placeholder: "{{firstName}}" },
      { dataName: "Last Name", placeholder: "{{lastName}}" },
      { dataName: "Business/Company Name", placeholder: "{{businessName}}" },
      { dataName: "LL Expected NLD", placeholder: "{{llExpectedNLD}}" },
      { dataName: "Expected NLD", placeholder: "{{expectedNLD}}" },
      { dataName: "Date Added", placeholder: "{{dateAdded}}" },
      { dataName: "Plan Number", placeholder: "{{planNo}}" },
      { dataName: "Contact Email", placeholder: "{{email}}" },
      {
        dataName: "Bill Run Cycle Number",
        placeholder: "{{billRunCycleNumber}}",
      },
      { dataName: "End of Contract", placeholder: "{{contract_end}}" },
      { dataName: "Contract Term", placeholder: "{{contract_Term}}" },
    ];
    vm.rowData2 = [
      { dataName: "Group Number", placeholder: "{{groupNo}}" },
      { dataName: "Fax", placeholder: "{{fax}}" },
      { dataName: "Address", placeholder: "{{address1}}" },
      { dataName: "Address 2", placeholder: "{{address2}}" },
      { dataName: "Suburb", placeholder: "{{suburb}}" },
      { dataName: "State", placeholder: "{{state}}" },
      { dataName: "Postcode", placeholder: "{{postcode}}" },
      { dataName: "Date Today", placeholder: "{{date}}" },
      {
        dataName: "First Month of Unpaid Invoice",
        placeholder: "{{startmonth}}",
      },
      {
        dataName: "Latest Month of Unpaid Invoice",
        placeholder: "{{endmonth}}",
      },
      {
        dataName: "Length of Month(s) Overdue",
        placeholder: "{{overduemonth}}",
      },
      { dataName: "List of Invoices", placeholder: "{{listofinvoices}}" },
      { dataName: "Current Balance", placeholder: "{{balance}}" }
    ];
    vm.defaultColDef = {
      resizable: true,
      autoHeight: true,
    };
  },
};
</script>
<style scoped>
.col.inner-col {
  border: 1px solid #ccc;
}
</style>